import { render } from "./DownloadFile.vue?vue&type=template&id=1f3e3aa7"
import script from "./DownloadFile.vue?vue&type=script&lang=js"
export * from "./DownloadFile.vue?vue&type=script&lang=js"
script.render = render

export default script